import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { DialogModule } from "../dialog/index";

import { ImageBaseModule } from "./image.base.module";

import { ImageComponent } from "./image.component";
import { ImageViewerDirective } from "./viewer/viewer.directive";

export * from "./image.base.module";

export { ImageViewerDirective } from "./viewer/viewer.directive";

@NgModule({
  declarations: [ImageViewerDirective],
  imports: [CommonModule, ImageBaseModule, DialogModule],
  exports: [ImageComponent, ImageViewerDirective]
})
export class ImageModule {}
